import { Text, View } from "@aws-amplify/ui-react";
import { useTheme } from "@emotion/react";
export const CustomComponents = {
    Header() {
      const { tokens } = useTheme();
  
      return (
        <View textAlign="center" >
          <img src="/assets/images/icon3.png"alt="Logo" />;
        </View>
      );
    },
    Footer() {
        const { tokens } = useTheme();
    
        return (
          <View textAlign="center" >
            <Text color="white">
              &copy; All Rights Reserved
            </Text>
          </View>
        );
      },
};